
import { application } from "./application.js"
export class entities {
    /**
     *
     * @param {application} App
     * @returns
     */
    constructor(App) {
        this.App = App;

        this.markets = {};
        this.applications = {};
        this.assemblies = {};
        this.countries = {};
        this.provinces = {};
        this.sectors = {};
        this.themes = {};
        this.product_families = {};
        this.materials = {};
        this.interior = {
            0: { cl: 'Intemperie', de: 'Außenbereich', en: 'Outdoor', es: 'Intemperie', fr: 'Intempérie', it: 'Intemperie', pt: 'Exterior' },
            1: { cl: 'Interior', de: 'Innenbereich', en: 'Indoor', es: 'Interior', fr: 'Intérieur', it: 'Interno', pt: 'Interior' },
        };

    }

    async init() {
        await this.loadEntities();
    }

    /**
     * Carga una entidad concreta
     * @param {*} entity
     * @returns
     */
    async loadEntity(entity) {
        var self = this
        // eslint-disable-next-line
        try {
            var result = await this.App.api.get(
                '/' + entity + '?per_page=10000',
                {
                    // Authorization: obj.bearer
                })
            console.warn(result)
            for (var i = 0; i < result.data.length; i++) {
                self[entity][result.data[i].id] = result.data[i].text;
            }

            return true
        } catch (error) {
            throw error
        }

    }
    async loadProducts() {
        var response = await this.App.api.get(
            '/products?per_page=10000',
            {

            }
        )

        for (var i = 0; i < response.data.length; i++) {
            var product = response.data[i];
            var ids = product.id.split("_");
            var p_family = {};
            var material = {};
            for (var language in product.text) {
                p_family[language] = product.text[language].product_family;
                material[language] = product.text[language].material;
            }
            this.product_families[ids[0]] = p_family;
            this.materials[ids[1]] = material;
        }
    }

    async loadEntities() {
        var self = this

        //Load Entities
        await this.loadEntity('markets');
        await this.loadEntity('applications');
        await this.loadEntity('assemblies');
        await this.loadEntity('countries');
        await this.loadEntity('provinces');
        await this.loadEntity('sectors');
        await this.loadEntity('themes');

        await this.loadProducts();

        return
        // TODO: veure que fa
        this.getRequest(
            this.url + '/products?per_page=10000',
            {
                // Authorization: obj.bearer
            },
            function (response) {
                for (var i = 0; i < response.data.length; i++) {
                    var product = response.data[i];
                    var ids = product.id.split("_");
                    var p_family = {};
                    var material = {};
                    for (var language in product.text) {
                        p_family[language] = product.text[language].product_family;
                        material[language] = product.text[language].material;
                    }
                    self.product_families[ids[0]] = p_family;
                    self.materials[ids[1]] = material;
                }
                self.loadedEntities++;
                (self.onLoadEntity.bind(self))('product_families', self.product_families);
                self.loadedEntities++;
                (self.onLoadEntity.bind(self))('materials', self.materials);
            },
            this.async);
    }

}